import { z } from "zod";

const emailCheckCache = new Map<string, boolean>();
export const MemberEmailSchema = (
  originalEmail: string,
  emailExists: (email: string) => Promise<boolean>,
) =>
  z
    .object({
      email: z
        .string()
        .trim()
        .email()
        .min(1, "common.required")
        .pipe(
          z.string().refine(async (email) => {
            if (originalEmail === email) {
              return true;
            }
            if (emailCheckCache.has(email)) {
              return emailCheckCache.get(email);
            }
            const result = !(await emailExists(email));
            emailCheckCache.set(email, result);
            return result;
          }, "signUpScreen.validation.emailExists"),
        ),
      password: z.string().min(1, "common.required").optional(),
      passwordConfirm: z.string().min(1, "common.required").optional(),
    })
    .refine((data) => data.password === data.passwordConfirm, {
      message: "signUpScreen.validation.passwordsDoNotMatch",
      path: ["passwordConfirm"],
    });
